import { defineEvent } from '../types/event';
export var PRODUCT_CARD_COLOR_SWATCH_CLICK = defineEvent({
    platforms: [
        {
            name: 'Optimizely',
            alias: 'Clicks_on_Product_Card_Color_Swatches'
        }
    ]
});
